// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import { TimeSlot } from './TimeSlot';
import { BreakShift } from './BreakShift';
import { AddressLatLng } from './AddressLatLng';

import type { TimeSlotModelType } from './TimeSlot';
import type { BreakShiftModelType } from './BreakShift';
import type { AddressLatLngModelType } from './AddressLatLng';

type DayOfWeekTypeEnum =
    | 'SUNDAY'
    | 'MONDAY'
    | 'TUESDAY'
    | 'WEDNESDAY'
    | 'THURSDAY'
    | 'FRIDAY'
    | 'SATURDAY';

export type DayShiftModelType = {
    dayOfWeek: DayOfWeekTypeEnum,
    slot: TimeSlotModelType,
    breaks?: Array<BreakShiftModelType>,
    startLocation?: AddressLatLngModelType,
    endLocation?: AddressLatLngModelType,
    endDayOffset?: number
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class DayShift extends ImmutableModel {
    static fromJS(json: DayShiftModelType): DayShift {
        const state: Object = Object.assign({}, json);
        state.slot = TimeSlot.fromJS(state.slot);
        state.breaks = state.breaks
            ? Immutable.List(state.breaks).map(item => BreakShift.fromJS(item))
            : state.breaks;
        state.startLocation = state.startLocation
            ? AddressLatLng.fromJS(state.startLocation)
            : state.startLocation;
        state.endLocation = state.endLocation
            ? AddressLatLng.fromJS(state.endLocation)
            : state.endLocation;
        return new this(Immutable.Map(state));
    }

    toJS(): DayShiftModelType {
        const js: DayShiftModelType = {
            dayOfWeek: this.dayOfWeek,
            slot: this.slot.toJS()
        };

        if (this.breaks != null) {
            js.breaks = this.breaks
                ? this.breaks.toArray().map(item => item.toJS())
                : this.breaks;
        }

        if (this.startLocation != null) {
            js.startLocation = this.startLocation
                ? this.startLocation.toJS()
                : this.startLocation;
        }

        if (this.endLocation != null) {
            js.endLocation = this.endLocation
                ? this.endLocation.toJS()
                : this.endLocation;
        }

        if (this.endDayOffset != null) {
            js.endDayOffset = this.endDayOffset;
        }

        return js;
    }

    get dayOfWeek(): DayOfWeekTypeEnum {
        return this._state.get('dayOfWeek');
    }

    setDayOfWeek(dayOfWeek: DayOfWeekTypeEnum): this {
        return this.clone(this._state.set('dayOfWeek', dayOfWeek));
    }

    get slot(): TimeSlot {
        return this._state.get('slot');
    }

    setSlot(slot: TimeSlot): this {
        return this.clone(this._state.set('slot', slot));
    }

    get breaks(): ?Immutable.List<BreakShift> {
        return this._state.get('breaks');
    }

    setBreaks(breaks: ?Immutable.List<BreakShift>): this {
        return this.clone(this._state.set('breaks', breaks));
    }

    get startLocation(): ?AddressLatLng {
        return this._state.get('startLocation');
    }

    setStartLocation(startLocation: ?AddressLatLng): this {
        return this.clone(this._state.set('startLocation', startLocation));
    }

    get endLocation(): ?AddressLatLng {
        return this._state.get('endLocation');
    }

    setEndLocation(endLocation: ?AddressLatLng): this {
        return this.clone(this._state.set('endLocation', endLocation));
    }

    get endDayOffset(): ?number {
        return this._state.get('endDayOffset');
    }

    setEndDayOffset(endDayOffset: ?number): this {
        return this.clone(this._state.set('endDayOffset', endDayOffset));
    }
}
